import React, { Component } from "react";
import sanitizeHtml from "sanitize-html";

class AccountDetailsFieldset extends Component {
	constructor(props) {
		super(props);

		this.dataProps = ["date_added", "date_edited"];
	}

	shouldComponentUpdate(nextProps) {
		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults;
	}

	render() {
		const { data } = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">Account Details</div>
				<div className="fieldset-indent">
					<div className="form-field pt1">
						<label>Reason Reviewer Joined:</label>
						{data.comments ? <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.comments) }} /> : "Reviewer did not enter a reason."}
					</div>

					<div className="form-field pt2">
						<div className="pb1">
							<em>Date Joined: {data.date_added}</em>
						</div>
						<div>
							<em>Date Last Edited: {data.date_edited}</em>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default AccountDetailsFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/reviewers/form-components/AccountDetailsFieldset.js